(function () {
  var collectionMatch = window.location.pathname.replace(/\/+$/, '').match(/^\/collections\/([^/?#]+)/);
  if (!collectionMatch) return;

  var collectionHandle = decodeURIComponent(collectionMatch[1]);
  var url = '/collections/' + encodeURIComponent(collectionHandle) + '/products.json?limit=250&_mf=' + Date.now();

  function normalizeTitle(value) {
    return String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function withWidth(src, width) {
    if (!src) return '';
    var normalized = String(src).replace(/^\/\//, 'https://');
    return normalized + (normalized.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function srcsetFor(src) {
    return [165, 360, 533, 720, 940, 1066]
      .map(function (width) {
        return withWidth(src, width) + ' ' + width + 'w';
      })
      .join(',');
  }

  var scheduled = false;

  function createRefresh(liveByTitle) {
    return function refreshCards() {
      document.querySelectorAll('.product-card-wrapper').forEach(function (card) {
        var titleLink = card.querySelector('.card__heading a');
        if (!titleLink) return;

        var titleKey = normalizeTitle(titleLink.textContent);
        var liveProduct = liveByTitle.get(titleKey);
        if (!liveProduct || !liveProduct.handle) return;

        var livePath = '/products/' + liveProduct.handle;
        var currentPath = titleLink.getAttribute('href') || '';
        if (currentPath === livePath) return;

        card.querySelectorAll('a[href^="/products/"]').forEach(function (link) {
          link.setAttribute('href', livePath);
        });

        var images = Array.isArray(liveProduct.images) ? liveProduct.images : [];
        card.querySelectorAll('img').forEach(function (image, index) {
          var productImage = images[index] || images[0];
          if (!productImage || !productImage.src) return;

          image.src = withWidth(productImage.src, 533);
          image.srcset = srcsetFor(productImage.src);
          image.alt = liveProduct.title || image.alt || '';
        });

        card.setAttribute('data-makefield-cache-guard', 'refreshed');
      });
    };
  }

  fetch(url, { cache: 'no-store', credentials: 'same-origin' })
    .then(function (response) {
      return response.ok ? response.json() : null;
    })
    .then(function (payload) {
      var products = payload && Array.isArray(payload.products) ? payload.products : [];
      if (!products.length) return;

      var liveByTitle = new Map();
      products.forEach(function (product) {
        var titleKey = normalizeTitle(product.title);
        if (titleKey && product.handle && !liveByTitle.has(titleKey)) {
          liveByTitle.set(titleKey, product);
        }
      });

      var refreshCards = createRefresh(liveByTitle);
      refreshCards();

      if (window.MutationObserver && document.body) {
        var observer = new MutationObserver(function () {
          if (scheduled) return;
          scheduled = true;
          window.requestAnimationFrame(function () {
            scheduled = false;
            refreshCards();
          });
        });

        observer.observe(document.body, { childList: true, subtree: true });
        window.setTimeout(function () {
          observer.disconnect();
        }, 15000);
      }
    })
    .catch(function () {
      // Keep collection rendering resilient if Shopify's JSON endpoint is unavailable.
    });
})();
